import React, { useEffect } from "react";
import "./timeline.css";

function Timeline() {
  const handleScrollTo = (id) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("fade-in");
          } else {
            entry.target.classList.remove("fade-in");
          }
        });
      },
      { threshold: 0.1 }
    );

    const items = document.querySelectorAll(".content-item");
    items.forEach((item) => {
      observer.observe(item);
    });

    return () => {
      items.forEach((item) => {
        observer.unobserve(item);
      });
    };
  }, []);

  return (
    <div className="timeline-container container">
      <div className="timeline-content">
        <div className="content-item" id="discovery">
          <h3>Discovery</h3>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <img
              src="/assets/projects/juz-delights-design.png"
              alt="Juz Delights Research image"
              style={{ maxWidth: "50%" }}
            />
            <p className="case-study-text" style={{ maxWidth: "50%" }}>
              During the Discovery phase, we dived deep into understanding the
              needs and goals of Juz Delights. This involved going through
              existing copywriting and research, including <strong className="highlight">market analysis</strong> and
              <strong className="highlight"> competitor benchmarking</strong>.
            </p>
          </div>
        </div>
        <br />
        <br />
        <div className="content-item" id="design">
          <h3>Design</h3>
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <p className="case-study-text" style={{ maxWidth: "45%" }}>
              Our main goal was to ensure a <strong className="highlight">smooth customer journey</strong> while
              keeping the site as simple as possible. Our client does not have
              the bandwidth to maintain the website, so we want to ensure that
              it is <strong className="highlight">easy for them to make changes</strong> to and truly fits their needs.
            </p>
            <img
              src="/assets/projects/juz-delights-sitemap.png"
              alt="Juz Delights Research image"
              style={{ maxWidth: "55%" }}
            />
          </div>
        </div>
        <br />
        <br />
        <div className="content-item" id="prototypes">
          <h3>Prototypes</h3>
          <div className="row">
            <div className="col">
              <img
                src="/assets/projects/juz-delights-wireframes.png"
                alt="Juz Delights Wireframe"
                className="banner-image"
              />
            </div>
            <div className="col">
              <img
                src="/assets/projects/juz-delights-midfi.png"
                alt="Juz Delights Wireframe"
                className="banner-image"
              />
            </div>
          </div>
          <br />
          <br />
          <br />
          <br />
          <br />
          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "stretch", // Ensure columns stretch to equal height
            }}
          >
            <div
              className="col-md-4"
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <img
                src="/assets/projects/jd-ipad1.png"
                alt="Juz Delights ipadimg1"
                className="ipadImg"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  marginBottom: "1vw",
                }}
              />
              <div
                style={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <h4 style={{ fontFamily: "var(--font-heading)", fontSize: "1.2rem", fontWeight: "600", color: "var(--color-primary)", marginBottom: "var(--spacing-sm)", marginTop: "0" }}>
                  User Friendly Product Ordering
                </h4>
                <p className="case-study-text" style={{ margin: "0" }}>
                  Product pages are very simple with <strong className="highlight">clear call-to-actions</strong> and
                  multiple ways to share information with others.
                </p>
              </div>
            </div>

            <div
              className="col-md-4"
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <img
                src="/assets/projects/jd-ipad2.png"
                alt="Juz Delights ipadimg2"
                className="ipadImg"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  marginBottom: "1vw",
                }}
              />
              <div
                style={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <h4 style={{ fontFamily: "var(--font-heading)", fontSize: "1.2rem", fontWeight: "600", color: "var(--color-primary)", marginBottom: "var(--spacing-sm)", marginTop: "0" }}>
                  Clear FAQ and Location Information
                </h4>
                <p className="case-study-text" style={{ margin: "0" }}>
                  Organized location and FAQ sections that <strong className="highlight">reduce friction</strong> in
                  accessing information and reduce support requests.
                </p>
              </div>
            </div>

            <div
              className="col-md-4"
              style={{
                textAlign: "center",
                display: "flex",
                flexDirection: "column",
              }}
            >
              <img
                src="/assets/projects/jd-ipad3.png"
                alt="Juz Delights ipadimg3"
                className="ipadImg"
                style={{
                  maxWidth: "100%",
                  height: "auto",
                  marginBottom: "1vw",
                }}
              />
              <div
                style={{
                  flexGrow: 1,
                  display: "flex",
                  flexDirection: "column",
                  justifyContent: "space-between",
                  height: "100%",
                }}
              >
                <h4 style={{ fontFamily: "var(--font-heading)", fontSize: "1.2rem", fontWeight: "600", color: "var(--color-primary)", marginBottom: "var(--spacing-sm)", marginTop: "0" }}>
                  Client's Purpose
                </h4>
                <p className="case-study-text" style={{ margin: "0" }}>
                  We made sure to authentically narrate the client's goals and
                  ensure all of our <strong className="highlight">design decisions</strong> aligned with the client's
                  <strong className="highlight"> core mission</strong>.
                </p>
              </div>
            </div>
          </div>
        </div>

        <br />
        <br />
        <div className="content-item" id="build">
          <h3>Build</h3>

          <div className="row">
            <p className="case-study-text" style={{ maxWidth: "65%" }}>
              Our website was built quickly using <strong className="highlight">Ecwid</strong>.
              We customized it to fit our design and did a final review for any
              last-minute changes or adjustments.
            </p>
          </div>
        </div>
        <br />
        <br />
        <div className="content-item" id="more-user-testing">
          <h3>User Testing</h3>

          <div
            className="row"
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              textAlign: "center",
            }}
          >
            <div
              className="col"
              style={{
                maxWidth: "60%",
                marginRight: "2wv",
              }}
            >
              <p className="case-study-text">
                After preparing a script covering our general website design and
                our client's concerns. We conducted <strong className="highlight">user interviews</strong> with
                multiple individuals through zoom. By watching them walk through
                the website, we were able to identify <strong className="highlight">confusing features</strong> and
                revise.
              </p>
              <p className="case-study-text">
                Through the <strong className="highlight">re:bloom program</strong>, we were also able to complete a
                critique session with multiple volunteers.
              </p>
            </div>

            <div className="col">
              <img
                src="/assets/projects/juz-delights-roundtable.png"
                alt="Juz Delights Research image"
                style={{ maxWidth: "80%" }}
                className="col"
              />
            </div>
          </div>
        </div>
        <div className="content-item" id="launch">
          <h3>Launch</h3>
          <p>Coming soon</p>
        </div>
      </div>
    </div>
  );
}

export default Timeline;
